import type { MenuItem } from "@/modules/menu";

import { useLanguageMenuItem } from "@/modules/language/language-menu-item";
import {
  useMenuItemLink,
  useMenuItemLogoutAction,
  useMenuSelectedKeys,
} from "@/modules/menu";

export const useUserDropdownMenu = () => {
  const languageMenuItem = useLanguageMenuItem();

  const menuItems: MenuItem[] = [
    useMenuItemLink("preferencesNotifications"),
    useMenuItemLink("preferencesPassword"),
    languageMenuItem,
    { type: "divider" },
    useMenuItemLogoutAction(),
  ];

  const { selectedKeys } = useMenuSelectedKeys(menuItems);

  return {
    items: menuItems,
    selectedKeys,
  };
};
